<template>
  <svg
    class="w-auto transition-fill"
    :style="style"
    viewBox="0 0 509.88 60"
    preserveAspectRatio="xMidYMid meet"
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Artwork">
        <path
          :fill="hex"
          d="M255.23,10a5,5,0,1,0-5.06-5.13A5,5,0,0,0,255.23,10Z"
        />
        <path
          :fill="hex"
          d="M0,5.67H2.63C6.55,5.6,7,6.14,7,9.85V36.24c0,3.72-.47,4.25-4.39,4.19H0v5.13H24.09V40.43H20.92c-4,.06-4.45-.47-4.45-4.19V24.63h1.21c5.6-.13,6.55,1.15,7.09,9.18H29.9V11.34H24.77c-.68,7.42-1.15,8-7.15,8.17H16.47V5.67h8.37C34.22,5.53,36.45,8,36.65,19.24h5.13V.54H0Z"
        />
        <path
          :fill="hex"
          d="M85.63,12.76c-10.66,0-17.89,6.75-17.89,16.73,0,10.53,7,17.21,18,17.21,10.67,0,17.76-6.74,17.76-16.94S96.43,12.76,85.63,12.76Zm0,29.22c-5.87,0-8.71-4-8.71-12.42,0-8,2.91-12.08,8.71-12.08s8.71,4.05,8.71,12.22S91.43,42,85.63,42Z"
        />
        <path
          :fill="hex"
          d="M129.09,13c-3.64,0-6,1.55-8.57,5.6V13.9h-14.1v4.53h2.16c3.37.13,3.84.6,3.84,4V37.05c0,3.31-.47,3.78-3.84,4h-2.16v4.53h21.32V41h-3.37c-3.37-.13-3.85-.67-3.85-4V28.48a15.7,15.7,0,0,1,2.16-8.37c1.42-2.09,3.66-3.55,5.64-3.55,2.33,0,2.54.72,2.54.72-2.9.94-3.79,2.23-3.79,4.52,0,2.5,1.82,4.12,4.59,4.12a5.33,5.33,0,0,0,5.4-5.67C137.06,16.06,133.68,13,129.09,13Z"
        />
        <path
          :fill="hex"
          d="M59.59,37.05V.54H45.49V5.06h2c3.45.14,3.92.61,3.92,4v28c0,3.38-.47,3.85-3.92,4h-2v4.53h20V41H63.44C60.07,40.9,59.59,40.43,59.59,37.05Z"
        />
        <path
          :fill="hex"
          d="M167.5,17.48c-2.57-3.17-6.35-4.72-11.41-4.72-10,0-16.67,6.88-16.67,17.07s6.55,16.94,16.4,16.94a16,16,0,0,0,10.33-3.24c2.76-2.16,3.91-4.38,4.79-9.24h-5.6c-.81,3-1.49,4.32-2.7,5.4a8.87,8.87,0,0,1-5.6,1.68,7.07,7.07,0,0,1-6.35-3c-1.28-1.89-1.82-3.72-2.09-8h22.54C170.87,23.62,170,20.52,167.5,17.48Zm-18.63,8.17c1.08-5.94,3.24-8.44,7.22-8.44s5.47,2.23,6.21,8.44Z"
        />
        <path
          :fill="hex"
          d="M460.13,13c-3.64,0-6,1.55-8.57,5.6V13.9h-14.1v4.53h2.16c3.37.13,3.84.6,3.84,4V37.05c0,3.31-.47,3.78-3.84,4h-2.16v4.53h21.33V41h-3.38c-3.37-.13-3.85-.67-3.85-4V28.48a15.7,15.7,0,0,1,2.16-8.37c1.42-2.09,3.66-3.55,5.64-3.55,2.33,0,2.54.72,2.54.72-2.9.94-3.79,2.23-3.79,4.52,0,2.5,1.82,4.12,4.59,4.12a5.33,5.33,0,0,0,5.4-5.67C468.1,16.06,464.72,13,460.13,13Z"
        />
        <path
          :fill="hex"
          d="M389.67,38.07a2.47,2.47,0,0,1-2.7,2.42c-1.75,0-2.36-.94-2.36-3.91v-18h8.84V13.9h-8.7V1.48H380.5c-.81,8.64-2.77,11.28-9.18,12.69v4.39h5.19V35.64c0,4,.41,5.93,1.56,7.76,1.41,2.22,3.71,3.3,6.88,3.3,3.85,0,6.68-1.48,8-4.25,1.15-2.29,1.49-4.59,1.49-9.45V30.64h-4.39C390,36,390,36.58,389.67,38.07Z"
        />
        <path
          :fill="hex"
          d="M416.67,12.76c-10.66,0-17.88,6.75-17.88,16.73,0,10.53,6.95,17.21,18,17.21,10.66,0,17.75-6.74,17.75-16.94S427.47,12.76,416.67,12.76Zm0,29.22c-5.87,0-8.71-4-8.71-12.42,0-8,2.91-12.08,8.71-12.08s8.71,4.05,8.71,12.22S422.47,42,416.67,42Z"
        />
        <path
          :fill="hex"
          d="M493.68,13.9v4.53h1.82c2.1,0,3,.47,3,1.68a6.69,6.69,0,0,1-.47,2l-5.53,14-6.21-14.58a3.6,3.6,0,0,1-.41-1.62c-.06-.94.81-1.48,2.37-1.48h2.29V13.9H471.14v4.53h2c2.5.13,3.51,1,4.93,4l10.33,23.09c-3.17,7.76-5.2,10-8.84,10A3.66,3.66,0,0,1,476.2,54c3.31,0,4.93-1.35,4.93-4a4.42,4.42,0,0,0-4.66-4.45c-3.24,0-5.53,2.43-5.53,6,0,4.86,4,8.44,9.38,8.44,6.55,0,9.79-3.78,15.59-18.22l7.56-18.56c1.62-3.65,2.63-4.66,4.93-4.79h1.48V13.9Z"
        />
        <path
          :fill="hex"
          d="M259.82,37.05V13.9H245.38v4.53h2.43c3.37.13,3.85.67,3.85,4V37.05c0,3.31-.48,3.85-3.85,4h-2.43v4.53h20.31V41h-2C260.3,40.9,259.82,40.36,259.82,37.05Z"
        />
        <path
          :fill="hex"
          d="M291.54,13c-3.64,0-6,1.55-8.57,5.6V13.9h-14.1v4.53H271c3.37.13,3.84.6,3.84,4V37.05c0,3.31-.47,3.78-3.84,4h-2.16v4.53h21.32V41h-3.37c-3.38-.13-3.85-.67-3.85-4V28.48a15.7,15.7,0,0,1,2.16-8.37c1.42-2.09,3.66-3.55,5.64-3.55,2.32,0,2.54.72,2.54.72-2.9.94-3.79,2.23-3.79,4.52,0,2.5,1.82,4.12,4.59,4.12a5.33,5.33,0,0,0,5.4-5.67C299.51,16.06,296.13,13,291.54,13Z"
        />
        <path
          :fill="hex"
          d="M358.29,23.76c0,2.63,2,4.45,4.86,4.45,3.11,0,5.27-2.29,5.27-5.74,0-5.6-5.54-9.71-13.23-9.71-10.4,0-17.48,7-17.48,17.14S344.12,46.7,354,46.7c4.86,0,8.64-1.48,11-4.38,1.89-2.43,2.7-4.79,3.18-9.92H363c-1,6-3.11,8.23-7.83,8.23-5.47,0-8.3-3.71-8.3-11,0-8,3.57-12.49,9-12.49,2.91,0,4.61.63,6.28,2.43C359.51,20,358.29,21.39,358.29,23.76Z"
        />
        <path
          :fill="hex"
          d="M217.69.54H192.18V5.67h2.63c3.91-.07,4.38.47,4.38,4.12V36.31c0,3.65-.47,4.18-4.38,4.12h-2.63v5.13h25.51c15.66,0,23.82-7.7,23.82-22.48S233.35.54,217.69.54Zm9.24,36.31c-2.36,2.7-5.46,3.58-12.42,3.58h-5.87V5.67h5.87c7,0,10.06.88,12.42,3.58,2.57,2.9,4,7.89,4,13.83S229.5,34,226.93,36.85Z"
        />
        <path
          :fill="hex"
          d="M330,17.48c-2.57-3.17-6.35-4.72-11.41-4.72-10,0-16.67,6.88-16.67,17.07s6.55,16.94,16.4,16.94a16,16,0,0,0,10.33-3.24c2.76-2.16,3.91-4.38,4.79-9.24h-5.6c-.81,3-1.49,4.32-2.7,5.4a8.88,8.88,0,0,1-5.61,1.68,7.06,7.06,0,0,1-6.34-3c-1.28-1.89-1.82-3.72-2.09-8h22.54C333.32,23.62,332.44,20.52,330,17.48Zm-18.63,8.17c1.08-5.94,3.24-8.44,7.22-8.44s5.47,2.23,6.21,8.44Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import { colors } from "@utils/tailwind";

export default {
  name: "BlockLogotype",

  props: {
    color: {
      type: String,
      default: "brown"
    },
    height: {
      type: Number,
      default: 60
    }
  },

  computed: {
    hex() {
      return colors[this.color];
    },
    style() {
      return {
        height: `${this.height}px`
      };
    }
  }
};
</script>

<style scoped>
.transition-fill {
  transition-property: fill;
  transition-duration: var(--transition-short);
  transition-timing-function: var(--transition-ease-in);
}
</style>
